export default __webpack_public_path__ + "image/header@3x-fb4b0f2f.jpg";